import { Link, navigate } from 'gatsby'
import React from 'react'
import ProjectPreview from './project-preview'

import * as styles from './project-preview-grid.module.css'
import { PropTypes } from 'prop-types'
import { OutlinedButton } from "../Button/OutlinedButton";

function ProjectPreviewGrid (props) {
  const {title, browseMoreHref, nodes} = props
  return (
    <div className={styles.root}>
      {title && (
        <h2 className={styles.headline}>
          {browseMoreHref ? (
            <Link to={browseMoreHref}>{title}</Link>
          ) : (
            title
          )}
        </h2>
      )}
      <ul className={styles.grid}>
        {nodes &&
          nodes.map(node => (
            <li key={node.id}>
              <ProjectPreview {...node} />
            </li>
          ))}
      </ul>
      {browseMoreHref && (
        <div className={styles.browseMoreNav}>
          <OutlinedButton buttonText='Se flere' withArrow
                          onClick={() => navigate(`${browseMoreHref}`)} />
        </div>
      )}
    </div>
  )
}

ProjectPreviewGrid.defaultProps = {
  title: '',
  nodes: [],
  browseMoreHref: '/projects'
}

ProjectPreviewGrid.propTypes = {
  title: PropTypes.string,
  nodes: PropTypes.array,
  browseMoreHref: PropTypes.string
}

export default ProjectPreviewGrid
